export default {
  'component.fileManager.label.baseDir': 'Путь',
  'component.fileManager.label.folders': 'Директории',
  'component.fileManager.label.files': 'Файлы',
  'component.fileManager.can-not-delete-root-dir': 'Нельзя удалить корневую директорию!',
};
